import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useURLParamState<T>(key: string, initialValue: T) {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialState = searchParams.get(key);
  const [state, setState] = useState(
    initialState ? JSON.parse(initialState) : initialValue
  );

  useEffect(() => {
    // Only add to URL if state has meaningful content
    const shouldAddToURL =
      state &&
      (typeof state !== 'object' ||
        (Array.isArray(state) && state.length > 0) ||
        (!Array.isArray(state) && Object.keys(state).length > 0));

    setSearchParams((prev) => {
      if (shouldAddToURL) {
        prev.set(key, JSON.stringify(state));
      } else {
        prev.delete(key);
      }
      return prev;
    }, { replace: true });
  }, [state, setSearchParams, key]);

  return [state, setState] as const;
}
